import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();

  // Si no hay un usuario autenticado, redirige al login
  if (!currentUser) {
    return <Navigate to="/Login" />;
  }

  // Si el usuario está autenticado, muestra la página protegida
  return children;
};

export default ProtectedRoute;
